import { formatMoney } from "~/utils/formatMoney"

const ProductsTable = ({ data, camp }) => {
  return (
    <table className="min-w-full table-auto divide-y divide-gray-300">
      <thead className="sticky top-0 bg-white shadow-sm">
        <tr>
          <th scope="col" className="py-3.5 w-1/12 text-left text-base font-semibold text-gray-900 whitespace-nowrap">
            Name
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Current Price
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Reservations
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Total Sold
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Net Total
          </th>
          <th scope="col" className="pl-3 py-3.5 text-right text-base font-semibold text-gray-900 whitespace-nowrap">
            Tax
          </th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {data &&
          data.map((addonData, index) => {
            const { name, current_price, reservation_quantity, quantity, total, tax_fee } = addonData

            return (
              <tr className="h-10 hover:bg-gray-50" key={index}>
                <td className="font-medium truncate max-w-xs">{name}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">
                  {formatMoney(current_price, camp?.currency)}
                </td>
                <td className="text-gray-500 text-right whitespace-nowrap">{reservation_quantity}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{quantity}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{formatMoney(total, camp?.currency)}</td>
                <td className="text-gray-500 text-right whitespace-nowrap">{formatMoney(tax_fee, camp?.currency)}</td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}
export default ProductsTable
